<template>
  <header>
    <div class="container">
      <div class="logo">
        <router-link v-if="!authenticatedArea" class="flex items-center" to="/">
          <img class="w-auto h-16 lg:h-20 mr-2" src="/img/mpa-logo.png" alt="MPA" />
          <span class="hidden sm:block">Membership Application</span>
        </router-link>
        <router-link v-else class="flex items-center" to="/authenticated/voting">
          <img class="w-auto h-16 lg:h-20 mr-2" src="/img/mpa-logo.png" alt="MPA" />
          <span class="hidden sm:block">Voting Member</span>
        </router-link>
      </div>

      <nav v-if="!authenticatedArea">
        <a
          href="#"
          class="button primary"
          :class="{ disabled: $v.$invalid, loading: saving }"
          role="button"
          @click.prevent="saveCurrentRegistration"
          v-if="showSaveApplication"
        >
          Save Application
        </a>
        <router-link to="/retrieve" class="button outline" role="button" v-else> Retrieve Application </router-link>
      </nav>
      <nav v-else>
        <router-link to="/authenticated/voting" class="menu-link-with-counter" role="button">
          <span>Membership Applications</span>
          <span class="menu-counter" :class="{ loading: isLoadingAuthUserTask }">
            {{ isLoadingAuthUserTask ? '' : notificationCountForMembershipApplication }}
          </span>
        </router-link>
        <router-link to="/authenticated/change-requests" class="menu-link-with-counter" role="button">
          <span>Member Change Requests</span>
          <span class="menu-counter" :class="{ loading: isLoadingNotificationItems }">
            {{ isLoadingNotificationItems ? '' : notificationCountForChangeRequests }}
          </span>
        </router-link>
        <router-link to="/logout" class="button primary" role="button"> Sign out </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import DialogService from '@/services/DialogService';

export default {
  name: 'PageHeader',
  mixins: [validationMixin],
  data() {
    return {
      showMobileMenu: false,
      saving: false,
    };
  },
  computed: {
    showSaveApplication() {
      return this.$route.path.indexOf('register') > -1 && this.$route.path.indexOf('/completed') < 0;
    },
    authenticatedArea() {
      return this.$route.path.indexOf('authenticated') > -1;
    },
    email() {
      return this.$store.state.registration.person?.email;
    },
    notificationCountForMembershipApplication() {
      if (this.authUser.role === 'Admin') {
        return this.authUserTask.Submitted;
      } else if (this.authUser.role === 'Voter') {
        return this.authUserTask.Verified;
      } else {
        return 0;
      }
    },
    notificationCountForChangeRequests() {
      const notificationItems = this.$store.getters['changeRequests/notificationItems'](this.authUser.id);
      return notificationItems?.length || 0;
    },
    isLoadingNotificationItems() {
      return this.$store.getters['changeRequests/isLoadingNotificationItems'];
    },
    isLoadingAuthUserTask() {
      return this.$store.getters['auth/isLoadingAuthUserTask'];
    },
    authUser() {
      return this.$store.getters['auth/authUser'];
    },
    authUserTask() {
      return this.$store.getters['auth/authUserTask'];
    },
  },
  validations: {
    email: { required, email },
  },
  watch: {
    'authUser.id': {
      handler: function () {
        this.$store.dispatch('changeRequests/getNotificationItems');
      },
    },
  },
  methods: {
    saveCurrentRegistration() {
      if (this.saving) {
        return;
      }
      this.$v.$touch();
      if (this.$v.$invalid) {
        DialogService.warning({
          title: 'Failed',
          message: 'You need to fill in a valid email address.',
        });
        return;
      }

      this.saving = true;
      this.$store
        .dispatch('saveAndNotifyRegistration')
        .then(() => {
          this.saving = false;
          this.$router.replace('/save');
        })
        .catch(() => {
          this.saving = false;
        });
    },
  },
  created() {
    if (this.authUser && this.authUser.id) {
      try {
        this.$store.dispatch('auth/getAuthUserTask');
      } catch (error) {
        console.error(error);
      }

      try {
        this.$store.dispatch('changeRequests/getNotificationItems');
      } catch (error) {
        console.error(error);
      }
    }
  },
};
</script>

<style scoped lang="scss">
.menu-counter.loading {
  color: transparent;
  position: relative;
}

.menu-counter.loading::after {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 999px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: counter-loading 0.8s linear infinite;
}

@keyframes counter-loading {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
</style>
